import React from 'react'
import './Footer.css';
import { Link } from 'react-router-dom';
function Footer() {
  return (
    <footer className='FooterSection'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-12 col-sm-12 col-xs-12'>
            <p>Copyright © {new Date().getFullYear()}  <Link to="https://maxworthsystems.com/" target='_blank'>Maxworth Electronic Systems Pvt Ltd.</Link> All rights reserved</p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer